import pubsub from "pubsub-js";
import store from "@/store/index";

import { mapState } from 'vuex';
import { getPaperCollectionList, getMathLevel, showTopicNames } from "@/api/chat/sendReceive";
import { showGraphNames } from "@/api/chat/knowledgeGraph";
import { getLevel, getRobotByLevel } from '@/utils/chat/chatUtil';
import { showTopic } from "../api/chat/sendReceive";


export default {
    computed: {
        ...mapState([
            // 这里可以添加你从 store 中获取的状态
            "messageStorage",
            "foldHistory",
            "robotSessionMap",
            "foldRobot",
            "isMobile",
            "papers",
            "robotId",
            "level"

        ])
    },
    data() {
        return {
            graphs: [],
            topics: [],
            paperShow: false,
            graphShow: false,
            topicShow: false,
            score: "",

        };
    },
    methods: {
        // 公共方法
        // 试题收藏：切换到作文智能体（composition），等切换完成后再加载试卷
        showPaper(paper) {
            const robotId = 'composition';
            // ★ 记录待办动作，等 getRouteInfo 完成会话激活/新建后再执行
            store.commit('SET_PENDING_ACTION', { type: 'getPaper', paper });
    
            if (this.robotId === robotId) {
            // 已在目标智能体，直接执行
            this.execPendingAction();
            } else {
            // 不带 sessionId 跳转，由 getRouteInfo 自动激活最新会话或新建
            this.$router.push(`/chatSearch/${robotId}`);
            }
    
            if (this.isMobile) {
            store.commit("SET_FOLDROBOT");
            this.$emit("hideCollect");
            }
        },
        // 图谱收藏：跳到按 level 对应的数学智能体，等切换完成后再加载图谱
        showGraph({ kgid, level }) {
            const robotId = getRobotByLevel(level);
            store.commit('SET_PENDING_ACTION', { type: 'getGraph', kgid, level });
            this.$message.info("正在加载图谱…");   // ★ 新增
            if (this.robotId === robotId) {
              this.execPendingAction();
            } else {
              this.$router.push(`/chatSearch/${robotId}`);
            }
            if (this.isMobile) {
              store.commit("SET_FOLDROBOT");
              this.$emit("hideCollect");
            }
          },
          
        // 展示某个专题：跳到按 level 对应的数学智能体，等切换完成后再加载专题
        showTopic(topic) {
            const { level } = topic;
            const robotId = getRobotByLevel(level);
            // ★ 记录待办动作，等切换完成后再执行
            store.commit('SET_PENDING_ACTION', { type: 'getTopic', topic });
    
            if (this.robotId === robotId) {
            this.execPendingAction();
            } else {
            this.$router.push(`/chatSearch/${robotId}`);
            }
    
            if (this.isMobile) {
            store.commit("SET_FOLDROBOT");
            this.$emit("hideCollect");
            }
        },

        // ★ 统一执行并清空待办动作（必须在会话激活完成后调用）
        execPendingAction() {
            const pending = store.state.pendingAction;
            if (!pending) return;
            store.commit('SET_PENDING_ACTION', null);
            switch (pending.type) {
            case 'getPaper':
                pubsub.publish('getPaper', { paper: pending.paper });
                break;
            case 'getGraph':
                pubsub.publish('getGraph', { kgid: pending.kgid, level: pending.level });
                break;
            case 'getTopic':
                pubsub.publish('getTopic', pending.topic);
                break;
            default:
                // questionCollect / wrong 等，走 getQuestionList 通道
                pubsub.publish('getQuestionList', { type: pending.type });
            }
        },
        // 试题收藏列表
        async getPaperCollectionNames() {
            let res = await getPaperCollectionList(); // 对应 showPaperNames
            if (!res || !res.data) return;
            // 直接存储后端返回的完整对象，不做任何转换
            store.commit("setPapers", res.data.papernames);
        },
        // 图谱收藏列表
        async getGraphCollectionNames() {
            this.graphs = [];
            let { data: res } = await showGraphNames();
            if (!res) return;
            if (!res.kgnames || res.kgnames.length < 1) return;  // ★ 修正：空列表直接返回
            this.graphs = res.kgnames.map((item) => {
              return { kgid: item[0], level: item[1] };
            });
          },

        // 专题收藏列表
        async getTopicCollectionNames() {
            this.topics = [];
            let { data: res } = await showTopicNames();
            if (!res) return;
            if (res.topicnames.length < 1) return
            this.topics = res.topicnames.map((item) => {
                return {
                    title: item[0],
                    level: item[1]
                }
            })

        },

        async getScore() {
            if (this.foldRobot && this.score !== "" && !this.isMobile) return
            this.score = "";
            let { data: res } = await getMathLevel();
            if (!res) return;
            this.score = res.mathlevel;
        },
        async choosedRobot(robotId) {
            // ★ 知识墙只属于高中/初中智能体：若当前是小学或组卷，先切到高中再加载
            if (robotId === "wall") {
                const WALL_ROBOTS = ["exercises", "mexercises"];
                if (!WALL_ROBOTS.includes(this.robotId)) {
                // 记录待办动作，等路由切换 + 会话激活完成后由 chatMain 执行
                store.commit('SET_PENDING_ACTION', { type: 'wall' });
                this.$router.push(`/chatSearch/exercises`);   // 默认跳高中智能体
                if (this.isMobile) {
                    store.commit("SET_FOLDROBOT", true);
                    this.$emit("hideCollect");
                }
                return;   // ★ 不再走后面的通用逻辑，避免 getQuestionList 提前发出
                }
                // 当前已是高中/初中：直接加载知识墙（走原通用逻辑）
                pubsub.publish("getQuestionList", { type: "wall" });
                if (this.isMobile) {
                store.commit("SET_FOLDROBOT", true);
                this.$emit("hideCollect");
                }
                return;
            }
            if (robotId === "collect") {
                if (this.foldRobot) {
                    store.commit("SET_FOLDROBOT", !this.foldRobot);
                    this.showCollect = true;
                    return
                } else {
                    this.showCollect = !this.showCollect;
                }
                return;
            } else if (robotId === "mathLevel") {
                if (this.foldRobot && !this.isMobile) {
                    store.commit("SET_FOLDROBOT", !this.foldRobot);
                }
                await this.getScore();

                return;
            }
            // 默认打开上次在这个智能体的对话
            if (["mexercises", "exercises","pexercises","composition"].includes(robotId)) {
                let sessionId = this.robotSessionMap[robotId];
                if (!sessionId) {
                    // ★ 该智能体没有任何历史会话，发布事件让 chatMain 自动新建
                    pubsub.publish("needNewSession", { robotId });
                } else {
                    this.$router.push(`/chatSearch/${robotId}/${sessionId.slice(-10)}`);
                }
            } else {
                if ("paperCollect" === robotId) {
                    this.paperShow = !this.paperShow;
                    if (!this.paperShow) return;
                    this.graphShow = false;
                    this.topicShow = false;
                    await this.getPaperCollectionNames();
                    return;
                } else if ("graphCollect" === robotId) {
                    this.graphShow = !this.graphShow;
                    if (!this.graphShow) return;
                    this.paperShow = false;
                    this.topicShow = false;
                    await this.getGraphCollectionNames();
                    return;
                } else if ("topicCollect" === robotId) {
                    this.topicShow = !this.topicShow;
                    if (!this.topicShow) return;
                    this.graphShow = false;
                    this.paperShow = false;
                    await this.getTopicCollectionNames();
                    return
                } else {
                    let currentRobotId = this.robotId
                    let level = getLevel();
                    if (level === 'm') {
                        currentRobotId = "mexercises"

                    } else {
                        currentRobotId = "exercises"
                    }

                    if (robotId === 'knowledgeGraph') {
                        currentRobotId = 'exercises'
                    }
                    let sessionId = this.robotSessionMap[currentRobotId];
                    if (!sessionId) sessionId = +new Date() + "";
                    this.$router.push(`/chatSearch/${currentRobotId}/${sessionId.slice(-10)}`);
                }
                if (this.isMobile) {
                    store.commit("SET_FOLDROBOT", true)
                    this.$emit("hideCollect")
                }


                pubsub.publish("getQuestionList", {
                    type: robotId,
                });
            }
        },
    }
};    